import { flex } from '@flipster/styled-system/patterns';

export const selectors = flex({
  justify: 'flex-start',
  align: 'center',
  w: '100%',
  gap: 12,
  flexWrap: 'wrap',
});
